import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { dashboardStore } from 'store/DashboardStore';
import { formatAmount, getDocumentType, toBase64 } from '../../utils';
import BuySellService from 'services/buy-sell.service';
import './SipPayMethod.css';

const SipPayMethod = ({
  show,
  onClick,
  setPaymentMethod,
  paymentMethod,
  paymentProvider = 'RPY',
  setPaymentProvider = (_value: string) => {},
  setIsDisplayPayMethod,
}) => {
  // const [paymentMethod, setPaymentMethod] = useState('CUSTOMER_WALLET');
  const [summary] = dashboardStore((state: any) => [state.summary]);
  const [bankList, setBankList] = useState<any[]>([]);
  const [selectedBank, setSelectedBank] = useState('');
  const [isBankListLoading, setIsBankListLoading] = useState(false);

  useEffect(() => {
    const fetchBankList = async () => {
      setIsBankListLoading(true);
      try {
        const res: any = await BuySellService.getNetBankingBankList();
        if (res.status === 200 || res.status === 202) {
          setBankList(res.data?.data || []);
        } else {
          toast.error('Failed to fetch bank list.');
        }
      } catch (err) {
        toast.error('Something went wrong while fetching bank list.');
      } finally {
        setIsBankListLoading(false);
      }
    };

    if (paymentMethod === 'NEBK' && bankList.length === 0) {
      fetchBankList();
    }
    if (paymentMethod !== 'NEBK') {
      setSelectedBank('');
    }
  }, [paymentMethod]);

  /**
   * Set payment method value
   * @param e
   */
  const onChangePaymentMethod = async (e) => {
    const { value } = e.target;
    setPaymentMethod(value);
  };
  const closeFunc = ()=>{
    setIsDisplayPayMethod(false)
  }

  return (
    <Modal show={show} onHide={()=>closeFunc()} aria-labelledby='contained-modal-title-vcenter' centered>
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          Payment Method
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <Form.Group className='mb-3' controlId='paymentMethod'>
          <Form.Label>Payment Method</Form.Label>
          <Form.Select
            aria-label='Default select example'
            onChange={onChangePaymentMethod}
          >
            <option value='CUSTOMER_WALLET'>
              Wallet - ₹ {formatAmount(summary?.walletBalance)}
            </option>
            <option value='UPI'>UPI</option>
            <option value='NEBK'>Net Banking</option>
          </Form.Select>
        </Form.Group> */}
        <Form className='radio-div '>
          <Form.Check
            type='radio'
            label='Wallet'
            name='payment-group'
            value={'CUSTOMER_WALLET'}
            onChange={(e) => setPaymentMethod(e.target.value)}
            checked={paymentMethod == 'CUSTOMER_WALLET'}
          ></Form.Check>
          <Form.Check
            type='radio'
            label='UPI'
            name='payment-group'
            value={'UPI'}
            onChange={(e) => setPaymentMethod(e.target.value)}
            checked={paymentMethod == 'UPI'}
          ></Form.Check>
          <Form.Check
            type='radio'
            label='Net Banking'
            name='payment-group'
            value={'NEBK'}
            onChange={(e) => setPaymentMethod(e.target.value)}
            checked={paymentMethod == 'NEBK'}
          ></Form.Check>
        </Form>

        {paymentMethod === 'NEBK' && (
          <Form.Group className='mb-3 netbanking-bank-select mt-3'>
            <Form.Label>Select Bank</Form.Label>
            <Form.Select
              value={selectedBank}
              onChange={(e) => {
                setSelectedBank(e.target.value);
                const bank = bankList.find((b: any) => b.bankName === e.target.value);
                if (bank?.provider) setPaymentProvider(bank.provider);
              }}
              disabled={isBankListLoading || bankList.length === 0}
            >
              <option value=''>
                {isBankListLoading ? 'Loading banks...' : 'Select a bank'}
              </option>
              {bankList.map((bank: any) => (
                <option key={bank.bankName} value={bank.bankName}>
                  {bank.bankName}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='primary'
          size='sm'
          onClick={() => onClick(paymentMethod)}
        >
          Proceed
        </Button>
        {/* <div className='d-grid mb-3'>
          <Button
            variant='primary'
            onClick={() => checkPanRequirement(true, 'SELL')}
            className=''
            size='lg'
          >
            Proceed
          </Button>
        </div> */}
      </Modal.Footer>
    </Modal>
  );
};

export default SipPayMethod;
